import { showSuccess, showError } from './notification.js';

window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.support = window.wpbuoy.support || {};

function getForm() {
  return document.querySelector( '[id^="wpcf7-f1839"]' );
}

function populateUserFields() {
  const userData = window.wpbuoyCurrentUser;
  if ( ! userData ) return;
  const form = getForm();
  if ( ! form ) return;
  const map = {
    'your-first-name': userData.firstName,
    'your-last-name':  userData.lastName,
    'your-email':      userData.email,
  };
  Object.keys( map ).forEach( function ( name ) {
    const el = form.querySelector( 'input[name="' + name + '"]' );
    if ( el ) el.value = map[ name ];
  } );
}

window.wpbuoy.support.submit = function ( e ) {
  const form = getForm();
  if ( ! form ) return;
  const submit = form.querySelector( '[type="submit"]' );
  submit.classList.add( 'loading' );
  submit.disabled = true;
};

window.wpbuoy.support.showErrors = function ( event ) {
  if ( event.detail.apiResponse.status === 'validation_failed' ) {
    const form = getForm();
    if ( ! form ) return;
    const submit = form.querySelector( '[type="submit"]' );
    submit.classList.remove( 'loading' );
    submit.disabled = false;
    showError( event.detail.apiResponse.message );
  }
};

window.wpbuoy.support.showSuccess = function ( event ) {
  if ( event.detail.apiResponse.status === 'mail_sent' ) {
    const form = getForm();
    if ( ! form ) return;
    const submit = form.querySelector( '[type="submit"]' );
    form.reset();
    populateUserFields();
    submit.classList.remove( 'loading' );
    submit.disabled = false;
    showSuccess( event.detail.apiResponse.message );
  }
};

window.wpbuoy.support.eventListeners = function () {
  const form = getForm();
  if ( ! form ) return;
  populateUserFields();
  form.addEventListener( 'submit', window.wpbuoy.support.submit );
  document.addEventListener( 'wpcf7mailsent', window.wpbuoy.support.showSuccess );
  document.addEventListener( 'wpcf7invalid', window.wpbuoy.support.showErrors );
};

window.wpbuoy.support.eventListeners();
